import { useNavigate } from 'react-router-dom';

const types = [
  {
    label: 'Houses',
    count: '2,340',
    icon: 'ri-home-4-line',
    image: 'https://public.readdy.ai/ai/img_res/cdb1af199221de1b95c93de3db185927.jpg',
    value: 'House',
  },
  {
    label: 'Apartments',
    count: '4,120',
    icon: 'ri-building-2-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20apartment%20building%20exterior%2C%20urban%20setting%2C%20glass%20facade%2C%20contemporary%20architecture%2C%20city%20background%2C%20residential%20complex&width=400&height=300&seq=type2&orientation=landscape',
    value: 'Apartment',
  },
  {
    label: 'Villas',
    count: '890',
    icon: 'ri-community-line',
    image: 'https://readdy.ai/api/search-image?query=luxury%20villa%20exterior%2C%20Mediterranean%20style%2C%20private%20pool%2C%20manicured%20garden%2C%20elegant%20architecture%2C%20warm%20sunlight%2C%20premium%20property&width=400&height=300&seq=type3&orientation=landscape',
    value: 'Villa',
  },
  {
    label: 'Studios',
    count: '1,560',
    icon: 'ri-door-open-line',
    image: 'https://readdy.ai/api/search-image?query=modern%20studio%20apartment%20interior%2C%20compact%20smart%20design%2C%20efficient%20layout%2C%20stylish%20minimalist%20decor%2C%20city%20apartment%2C%20natural%20light&width=400&height=300&seq=type4&orientation=landscape',
    value: 'Studio',
  },
  {
    label: 'Penthouses',
    count: '340',
    icon: 'ri-building-line',
    image: 'https://readdy.ai/api/search-image?query=luxury%20penthouse%20rooftop%20terrace%2C%20city%20skyline%20view%2C%20outdoor%20furniture%2C%20modern%20design%2C%20high-rise%20building%2C%20exclusive%20property&width=400&height=300&seq=type5&orientation=landscape',
    value: 'Penthouse',
  },
  {
    label: 'Townhouses',
    count: '720',
    icon: 'ri-home-smile-line',
    image: 'https://readdy.ai/api/search-image?query=charming%20townhouse%20row%2C%20brick%20facade%2C%20colorful%20doors%2C%20tree-lined%20street%2C%20urban%20residential%2C%20classic%20architecture%2C%20neighborhood&width=400&height=300&seq=type6&orientation=landscape',
    value: 'Townhouse',
  },
];

const PropertyTypesSection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-amber-500 text-xs font-semibold uppercase tracking-widest mb-2">Browse by Category</p>
          <h2 className="text-4xl font-black text-stone-900">Explore Property Types</h2>
          <p className="text-stone-500 mt-3 max-w-xl mx-auto text-sm">
            From cozy studios to sprawling villas — find the property type that fits your lifestyle perfectly.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {types.map(type => (
            <button
              key={type.value}
              onClick={() => navigate(`/listings?type_prop=${type.value}`)}
              className="group relative rounded-2xl overflow-hidden cursor-pointer text-left"
            >
              <div className="w-full h-36 overflow-hidden">
                <img
                  src={type.image}
                  alt={type.label}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <p className="text-white font-bold text-sm">{type.label}</p>
                <p className="text-white/70 text-xs">{type.count} listings</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PropertyTypesSection;
